<template>
    <div class="app-container">
        <!-- 列表展示 -->
        <div class="common-section-bg common-section-body">
            <el-table
                v-loading="listLoading"
                size="mini"
                :data="tableData"
                style="width: 100%;"
                row-key="id"
                :tree-props="{
                    children: 'children',
                    hasChildren: 'hasChildren',
                }"
            >
                 <el-table-column prop="commName" label="小区" minwidth="180"></el-table-column>
                <el-table-column prop="resourceCode" label="资源code" minwidth="180">
                </el-table-column>
                <el-table-column prop="resourceName" label="资源名称" minwidth="180"></el-table-column>

                <el-table-column label="类型" minwidth="180">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">房屋</span>
                        <span v-if="scope.row.type == 2">车位</span>
                        <span v-if="scope.row.type == 3">车库</span>
                        <span v-if="scope.row.type == 4">储间</span>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="绑定时间" minwidth="180"></el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="200"
                >
                    <template slot-scope="scope">
                        <div class="btns-wrap">
                            <el-button
                                type="danger"
                                v-if="scope.row.type == 1"
                                @click="familyMember(scope.row)"
                                style="
                                    background: #fd962b;
                                    border-color: #fd962b;
                                "
                                >家庭成员</el-button
                            >
                            <el-button
                                type="danger"
                                v-if="scope.row.type == 2 || scope.row.type == 3"
                                @click="car(scope.row)"
                                style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                                >已绑车辆</el-button
                            >
                            <el-button
                              type="danger"
                              @click="deleterow(scope.row)"
                              style="
                                      background: rgb(255, 73, 73);
                                       border-color: rgb(255, 73, 73);
                                  "
                            >删除</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination
                v-show="total"
                :total="total"
                :page.sync="queryParam.page"
                :limit.sync="queryParam.size"
                @pagination="getList"
            />
        </div>
        <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showDrawer"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="660px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
                    <i
                        class="el-icon-circle-close close-btn pointer"
                        @click="closeDrawerFun"
                    />
                </div>
            </template>
            <div class="custom-content">
                <commonAdd
                    ref="commonAdd"
                    @onUpdateDrawer="onUpdateDrawer($event)"
                />
            </div>
        </el-drawer>
        <!-- 家庭成员 已绑定车辆 弹层 -->
        <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showDrawer2"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="660px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ content }}</div>
                    <i
                        class="el-icon-circle-close close-btn pointer"
                        @click="closeDrawerFun"
                    />
                </div>
            </template>
            <div class="custom-content">
                <familyMember v-if="content == '家庭成员'" ref="familyMember" @onUpdateDrawer="onUpdateDrawer($event)"></familyMember>
                <car ref="car" v-if="content == '已绑车辆'" @onUpdateDrawer="onUpdateDrawer($event)"></car>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import fetch from "@/api/tianzheng/member";
import Qu from "@/api/tianzheng/Qu";
import commonAdd from "./memberAdd.vue";
import familyMember from "./familyMember.vue";
import car from "./car.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            content:'',
            showDrawer2:false,
            queryParam: {
                name: "",
                phone: "",
                page: 1,
                size: 10,
            },
            total: 0,
            listLoading: false,
            tableData: [],
            isEdit: 0, // 0新增 1编辑
            showDrawer: false,
        };
    },
    components: {
        Pagination,
        commonAdd,
        familyMember,
        car
    },
    created() {
        this.queryParam.id = this.$route.query.id;
    },
    mounted() {
        this.getList();
    },
    methods: {
        familyMember(row){
          console.log("家庭成员页面初始化");
            let that = this;
            this.content = '家庭成员';
            this.showDrawer2 = true;
            // // 给组件传值
            let obj = {
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.$refs.familyMember.initFun(obj);
            });
        },
        car(row){
            let that = this
            this.content = '已绑车辆'
            this.showDrawer2 = true
            // 给组件传值
            let obj = {
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.$refs.car.initFun(obj);
            });
        },
        deleterow(row){
          // row.type == 1;// 删除房屋，row.type == 2 或3，删除子资源
          if(row.type !=1){// 删除子资源
            var that = this;
            that.$confirm("确认删除当前信息信息吗", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                // 调用接口
                fetch.cancelChildBind({ id: row.id }).then((res) => {
                  if (res.code == 200) {
                    that.$message.success(res.message);
                    that.getList();
                  } else {
                    that.$message.error(res.message);
                  }
                });
              })
              .catch(() => {});
          }else{// 删除房屋资源
            var that = this;
            that.$confirm("确认删除当前信息信息吗", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                // 调用接口
                fetch.cancelBindFw({ id: row.id }).then((res) => {
                  if (res.code == 200) {
                    that.$message.success(res.message);
                    that.getList();
                  } else {
                    that.$message.error(res.message);
                  }
                });
              })
              .catch(() => {});
          }

        },
        /**
         * @name: 更改状态
         * @param {*} val
         * @return {*}
         * @desc:
         */
        changeStatus(val) {
            let params = {
                id: val.id,
                status: val.status,
            };
            fetch.status(params).then((res) => {
                if (res.code == 200) {
                    this.getList();
                } else {
                    this.getList();
                    this.$message.error(res.message);
                }
            });
        },
        // 更新弹层状态
        onUpdateDrawer(status) {
            console.log("status", status);
            if (status == 1) {
                // 成功
                this.showDrawer = false;
                this.showDrawer2 = false;
                this.getList();
            } else if (status == -1) {
                // 失败
                this.showDrawer = false;
                this.showDrawer2 = false;
            }
        },
        /**
         * @name: 关闭弹层
         * @return {*}
         * @desc:
         */
        closeDrawerFun() {
            this.showDrawer = false;
            this.showDrawer2 = false;
            if (this.$refs.commonAdd) {
                this.$refs.commonAdd.resetForm();
            }
        },
        /**
         * @name: 点击子项 0新增 1编辑
         * @param {*} type
         * @param {*} id
         * @return {*}
         * @desc:
         */
        clickItem(type, row) {
            let that = this;
            this.showDrawer = true;
            this.isEdit = type;
            // 给组件传值
            let obj = {
                type: type,
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.$refs.commonAdd.initFun(obj);
            });
        },
        /* 查询按钮，页码重置，查询数据 */
        searchClick() {
            this.queryParam.page = 1;
            this.getList();
        },
        /* 查询tableData数据 */
        getList() {
            let that = this;
            this.listLoading = true;
            fetch.memberResource(that.queryParam).then((res) => {
                that.listLoading = false;
                that.tableData = res.result;
            });
        },
        remove(row) {
            let that = this;
            that.$confirm("确定删除该内容吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    // 调用接口
                    fetch.remove({ id: row.id }).then((res) => {
                        if (res.code == 200) {
                            that.$message.success(res.message);
                            that.getList();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}
</style>
